import {all} from 'redux-saga/effects';
import githubSearchSagas from './githubSearch/sagas';
import questionnaireSagas from './questionnaire/sagas';
import karieUsersSaga from './karieUsers/sagas';
import clientsSaga from './clients/sagas';
import devicesSaga from './devices/sagas';
import eventTypesSaga from './events/sagas';
import deviceEventsSaga from './deviceEvents/sagas';
import usersSaga from './users/sagas';
import accountsSaga from './accounts/sagas';
import authSagas from './auth/saga';
import supportDevicesSaga from './support/devices/sagas';
import scheduleSagas from './schedules/sagas';
import supportDocumentSagas from './support/documents/sagas';
import updatePackagesSaga from './updatePackages/sagas';
import notificationSaga from './notification/saga';
import monitoringSaga from './support/monitoring/sagas';
import customerDeviceSaga from './CustomerDevices/sagas';
import createManufacturingDevicesSaga from './manufacturing/saga'
import editManufacturingDeviceSaga from './manufacturing/saga'


export default function* devSaga() {
  yield all([
    accountsSaga(),
    authSagas(),
    clientsSaga(),
    devicesSaga(),
    eventTypesSaga(),
    deviceEventsSaga(),
    usersSaga(),
    githubSearchSagas(),
    questionnaireSagas(),
    karieUsersSaga(),
    supportDevicesSaga(),
    scheduleSagas(),
    supportDocumentSagas(),
    updatePackagesSaga(),
    notificationSaga(),
    monitoringSaga(),
    customerDeviceSaga(),
    // createManufacturingDevicesSaga(),
    editManufacturingDeviceSaga()
  ]);
}
